/* R&B · calm scroll for links to a place further down the same page (e.g. "How it works" on Made to Measure).
   About 0.7–1.2 s depending on distance, eased in and out; lands a little below the sticky header.
   Instant with 'Reduce motion', and stops as soon as the visitor scrolls themselves. Loaded once (guard). */
(function () {
  if (window.RbSmooth) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var raf = null;

  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  function headerOffset() {
    var h = document.querySelector('sticky-header');
    if (!h) return 0;
    var type = h.getAttribute('data-sticky-type');
    // 'on-scroll-up' hides the header while moving down, so only an always-sticky header takes space
    return type === 'always' || type === 'reduce-logo-size' ? h.getBoundingClientRect().height : 0;
  }

  function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

  function go(target) {
    var air = window.innerWidth >= 990 ? 48 : 24;
    var to = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - air);
    var from = window.pageYOffset, dist = to - from;
    if (reduce.matches || Math.abs(dist) < 4) { window.scrollTo(0, to); return; }
    var dur = Math.min(1200, Math.max(700, Math.abs(dist) * .6)), t0 = null;
    stop();
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      window.scrollTo(0, from + dist * ease(p));
      raf = p < 1 ? requestAnimationFrame(step) : null;
    }
    raf = requestAnimationFrame(step);
  }

  ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { window.addEventListener(ev, stop, { passive: true }); });

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a || a.classList.contains('skip-to-content-link') || a.hasAttribute('data-no-smooth')) return;
    var url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname || url.search !== location.search || url.hash.length < 2) return;
    var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!target) return;
    e.preventDefault();
    go(target);
    if (history.pushState) history.pushState(null, '', url.hash);
    // keyboard and screen-reader users continue from the new place
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });

  window.RbSmooth = { go: go };
})();
